import { createContext } from "react";

const MovementsContext = createContext();

export default MovementsContext;
